import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Location from '@/views/Location.vue'
import About from '@/views/About.vue'
import TeamMember from '@/views/TeamMember.vue'
import Reviews from '@/views/Reviews.vue'
import Reasons from '@/views/Reasons.vue'
import Traits from '@/views/Traits.vue'
import Stack from '@/views/Stack.vue'
import Compensation from '@/views/Compensation.vue'
import PageNotFound from '@/views/PageNotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    props: true,
    meta: {
      title: 'Home | MMK',
      breadcrumb: [{ name: '📝 MMK' }]
    }
  },
  {
    path: '/where-am-i',
    name: 'location',
    component: Location,
    props: true,
    meta: {
      title: 'Where am I? | MMK',
      breadcrumb: [{ name: '📝 MMK', link: '/' }, { name: '🌍 Where am I?' }]
    }
  },
  {
    path: '/who-am-i',
    name: 'about',
    component: About,
    props: true,
    meta: {
      title: 'Who am I? | MMK',
      breadcrumb: [{ name: '📝 MMK', link: '/' }, { name: '😺 Who am I?' }]
    }
  },
  {
    path: '/team/matic-krajnc',
    name: 'teamMember',
    component: TeamMember,
    props: true,
    meta: {
      title: 'Our Team, Matic Krajnc | MMK',
      breadcrumb: [
        { name: '📝 MMK', link: '/' },
        { name: '😺 Who am I?', link: '/who-am-i' },
        { name: 'Matic Krajnc' }
      ]
    }
  },
  {
    path: '/what-people-say-about-me',
    name: 'reviews',
    component: Reviews,
    props: true,
    meta: {
      title: 'What people say about me? | MMK',
      breadcrumb: [
        { name: '📝 MMK', link: '/' },
        { name: '💖 What people say about me?' }
      ]
    }
  },
  {
    path: '/reasons-to-hire',
    name: 'reasons',
    component: Reasons,
    props: true,
    meta: {
      title: 'Some reasons to hire me | MMK',
      breadcrumb: [
        { name: '📝 MMK', link: '/' },
        { name: '😘 Some reasons to hire me (and not)' }
      ]
    }
  },
  {
    path: '/my-traits',
    name: 'traits',
    component: Traits,
    props: true,
    meta: {
      title: 'Some traits about me | MMK',
      breadcrumb: [
        { name: '📝 MMK', link: '/' },
        { name: '👽 Some traits about me' }
      ]
    }
  },
  {
    path: '/my-stack',
    name: 'stack',
    component: Stack,
    props: true,
    meta: {
      title: 'My technical stack | MMK',
      breadcrumb: [
        { name: '📝 MMK', link: '/' },
        { name: '💻 My stack & experience' }
      ]
    }
  },
  {
    path: '/compensation',
    name: 'compensation',
    component: Compensation,
    props: true,
    meta: {
      title: 'How do we compensate? | MMK',
      breadcrumb: [
        { name: '📝 MMK', link: '/' },
        { name: '💴 How do we compensate?' }
      ]
    }
  },
  {
    path: '*',
    component: PageNotFound,
    meta: {
      title: '404 Page Not Found | MMK',
      breadcrumb: [{ name: '📝 MMK', link: '/' }]
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'MMK'
  next()
})

export default router
